export function getFilterOptionDisplayName(option) {
	switch (option) {
		// AI Inspect filters
		case 'category':
			return 'Category';
		case 'type':
			return 'Type';
		case 'severity':
			return 'Severity';
		case 'scan':
			return 'Scan';
		case 'plant':
			return 'Plant';
		case 'pltName':
			return 'Unit';
		case 'funcLocation':
			return 'Functional Location';
		case 'area':
			return 'Area';
		case 'system':
			return 'System';
		case 'subSystem':
			return 'Sub System';
		case 'processFunction':
			return 'Process Function';
		case 'lno':
			return 'Line Number';
		case 'fireZone':
			return 'Fire Zone';
		case 'discipline':
			return 'Discipline';
		case 'location':
			return 'Equipment Location';
		case 'lineSize':
			return 'Line Size';
		case 'pipeSpecification':
			return 'Pipe Specification';
		case 'structuralType':
			return 'Structural Type';
		case 'equipmentTags':
			return 'Equipment';
		case 'pipelineTags':
			return 'Pipeline';

		// Corrosion Analyser specific filters
		case 'title':
			return 'Title';
		case 'status':
			return 'Status';
		case 'priority':
			return 'Priority';
		case 'defectType':
			return 'Defect Type';
		case 'analyzerMode':
			return 'Analyzer Mode';
		case 'analyzerStatus':
			return 'Analyzer Status';
		case 'unit':
			return 'Unit';
		case 'level2D':
			return 'Level 2D';
		case 'fluidCode':
			return 'Fluid Code';
		case 'fluidDescription':
			return 'Fluid Description';

		default:
			return '_blank';
	}
}